module.exports = __webpack_public_path__ + "img/feature_buy_th.c81e8a50.png";